import { ContentLayout, Header, Tabs } from '@amzn/awsui-components-react';
import LabShutoffs from './LabShutoffs';
import LabMetrics from './LabMetrics';
import { useUser } from '@/src/store/user.context';
import { useApi } from '@/src/store/api.context';
import { useTranslation } from 'react-i18next';
import { i18nKeys } from '@/src/utils/i18n.utils';

const LabDashboard = () => {
  const { t } = useTranslation();
  const { user } = useUser();
  const { labDashboardAPI, eventsApi } = useApi();
  return (
    <ContentLayout disableOverlap header={<Header>{t(i18nKeys.labDashboard.title)}</Header>}>
      <Tabs
        tabs={[
          {
            id: 'LABS',
            label: t(i18nKeys.labDashboard.calendar.title),
            content: <LabMetrics labDashboardAPI={labDashboardAPI} eventsApi={eventsApi} />,
          },
          ...(user?.isSuperAdmin
            ? [{ id: 'SHUTOFFS', label: t(i18nKeys.labDashboard.shutoffs.title), content: <LabShutoffs /> }]
            : []),
        ]}
      />
    </ContentLayout>
  );
};

export default LabDashboard;
